<template>
    <v-layout row wrap >
        <v-flex xs12 sm12 md6 class="file-list-container">
            <v-list>
                <v-list-tile
                        v-for="uploadedFile in files"
                        :key="uploadedFile.name"
                        @click="selectFile(uploadedFile)"
                >
                    <v-list-tile-action>
                        <v-icon
                                v-if="uploadedFile.icon"
                                color="primary"
                        >
                            {{ uploadedFile.icon }}
                        </v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title v-text="uploadedFile.name"/>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-btn
                                flat
                                small
                                icon
                                color="red"
                                @click="deleteFile(uploadedFile)"
                        >
                            <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>
            </v-list>
        </v-flex>
        <v-flex xs12 sm12 md6 class="file-detail-container">
            <v-layout d-flex fill-height align-center justify-center class="text-xs-center">
                <v-scroll-y-transition mode="out-in">
                    <v-flex>
                        <v-card v-if="!selectedFile"
                                class="full-height self-centered title grey--text text--lighten-1 font-weight-light"
                                flat>
                            {{ $t('globalControls.fileInput.selectFile') }}
                        </v-card>
                        <v-card v-else
                                :key="selectedFile.name"
                                class="pt-0 mx-auto full-height"
                                flat
                        >
                            <v-card-text class="pa-1">
                                <v-flex shrink>
                                    <v-layout row wrap align-center justify-end @click="deselectFile()">
                                        <p class="mr-2 my-0">Close</p>
                                        <v-btn icon right class="mr-0">
                                            <v-icon color="red">mdi-close-circle</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-flex>

                                <v-avatar v-if="selectedFile.image" size="88" tile>
                                    <v-img :src="require('@/assets/img/files/png/' + selectedFile.image)"
                                           class="mb-4"></v-img>
                                </v-avatar>
                                <h3 class="headline mb-2">
                                    {{ selectedFile.name }}
                                </h3>
                                <v-divider></v-divider>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-layout column wrap align-center>
                                            <v-flex ma-1 text-xs-right>
                                                <strong>Size: </strong>{{ getDataDimension(selectedFile.data.size) }}
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-layout column wrap align-center>
                                            <v-flex ma-1text-xs-right>
                                                <strong>Last Modified: </strong>{{
                                                getDate(selectedFile.data.lastModifiedDate) }}
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-scroll-y-transition>
            </v-layout>
        </v-flex>
    </v-layout>
</template>


<script>
    import TimeService from "@/helpers/TimeService";
    import ConversionService from "@/helpers/ConversionService";

    export default {
        name: "FileInputDetails",
        props: ["options", "files"],
        data() {
            return {
                selectedFile: undefined,
            };
        },
        computed: {},
        mounted() {

        },
        methods: {
            deselectFile() {
                this.selectedFile = undefined;
            },
            selectFile(uploadedFile) {
                this.selectedFile = uploadedFile;
            },
            deleteFile(uploadedFile) {
                console.log(uploadedFile);
                let fileToDelete = {
                    refId: this.options.id,
                    fileName: uploadedFile.name,
                };
                this.selectedFile = uploadedFile;
                if (this.selectedFile.name === uploadedFile.name) {
                    this.selectedFile = undefined;
                }
                this.$store.dispatch("FileInputState/deleteFileInput", fileToDelete);
            },
            getDataDimension(sizeInBytes) {
                // automatically fits to the best format
                return ConversionService.fromBytesToGigaBytes(sizeInBytes);
            },
            getDate(date) {
                return TimeService.parseDate(date);
            },
        },
    };
</script>

<style lang="scss" scoped>

    .file-list-container {
        max-height: 50vh;
        //max-height: 400px;
        overflow-y: auto;
    }

    .file-list-container {
        max-height: 70vh;
        //max-height: 300px;
        overflow-y: auto;
    }

    .full-height {
        height: 100%;
    }

    .self-centered {
        align-self: center;
    }

</style>
